import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import Loading from './loading'
import 'bootstrap/dist/css/bootstrap.min.css'
import './app.css'
import ProgressBar from './ProgressBar/ProgressBar';
import { fetchPage, fetchMemberFitnessActivities, deserializeFitnessActivity, convertMetersToMiles } from './utils'
import {sumBy} from 'lodash'

import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

dayjs.extend(duration)
dayjs.extend(isBetween)
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(relativeTime)
dayjs.extend(utc)

const App = () => {
  const [loading, setLoading] = useState(false)
  const [amount, setAmount] = useState(0)
  const [target, setTarget] = useState(0)
  const [frp, setFrp] = useState()

  const search = window.location.search
  const params = new URLSearchParams(search)
  const slug = params.get('slug')
  const startDate = params.get('startDate') || '2025-10-21T23:00:00.000Z'
  const endDate = params.get('endDate') || '2026-01-22T23:00:00.000Z'

  const handleFetchIndividualFitness = () => Promise.resolve()
    .then(()=> setLoading(true))
    .then(()=> Promise.all([fetchMemberFitnessActivities({ page: `fundraising/${slug}`, allActivities: true }), fetchPage(slug, true, {includeTags: true})]))
    .then(([fitness, page])=>{
        const goal = page.tags.find(({tagDefinition: {id}}) => id === "DSFitnessGoalTargetMeters")?.value
        const fitnessActivities = fitness
          .map(item => ({ ...deserializeFitnessActivity(item), activityType: 'fitness' }))
          .filter(activity => {
            if (startDate && endDate && activity.activityType === "SWIM") {
              const activityDate = dayjs.utc(activity.createdAt)
              return activityDate.isSameOrAfter(startDate) && activityDate.isSameOrBefore(endDate)
            }

            return true
          })
        setAmount(sumBy(fitnessActivities, 'distance'))
        setTarget(goal)
        setFrp(page)
    })
    .then(() => setLoading(false))
    .catch(error => {
      setLoading(false)
      return Promise.reject(error)
    })

  useEffect(() => {
    handleFetchIndividualFitness()
  }, [])

  if (loading) {
    return (
      <div className='loading-container'>
        <div className='row'>
          <div className='col-12'>
            <div className='loading'>
              <Loading size={2} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <ProgressBar
      fitnessGoal={Math.ceil(convertMetersToMiles(target))}
      amount={amount}
      percentage={amount / target * 100}
      target={target}
      page={frp}
    />
  )
}

ReactDOM.render(<App />, document.getElementById('app'))









